<template>
  <div class="enterprise_form">
    <div class="tit">
      <span>项目入驻</span>
    </div>
    <div class="body_content">
      <el-form :model="params" ref="from" label-position="top">
        <h2>创始人信息</h2>
        <el-form-item
          label="创始人照片:"
          prop="founder_cover"
          :rules="[{ required: true, message: '请上传创始人照片', trigger: 'blur' }]"
        >
          <div class="myupload">
            <div class="myupload_l">
              <!-- <uploadImg :params="params" :apiParams="apiParams5"></uploadImg> -->
              <AppCropper :params="params" @uploadObj="uploadObj" :uploadParams="uploadParams" />
            </div>
            <div class="myupload_r">
              <p>1.请上传创始人个人工作照或生活照；</p>
              <p>2.尺寸200×200像素以上，文件格式：JPG、PNG；文件大小：500KB以内。</p>
              <p v-if="params.founder_coverPath">
                <a
                  target="_blank"
                  style="color: rgb(50, 130, 255); cursor: pointer; text-decoration: underline;"
                  :href="params.founder_coverPath"
                  download="创始人照片"
                >查看附件</a>
              </p>
              <!-- <div>
                <el-button type="primary" size="mini" @click="viewExamples('id_card')">查看示例</el-button>
              </div>-->
            </div>
          </div>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item
              prop="founder_name"
              label="创始人姓名："
              :rules="[{ required: true, message: '请填写创始人姓名', trigger: 'blur' }]"
            >
              <el-input
                class="input-width"
                v-model="params.founder_name"
                placeholder="请输入创始人姓名"
                maxlength="20"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="性别:"
              prop="founder_sex"
              :rules="[{ required: true, message: '请选择性别', trigger: 'blur' }]"
            >
              <el-radio-group v-model="params.founder_sex">
                <el-radio label="SexMan">男</el-radio>
                <el-radio label="SexWoMan">女</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              prop="founder_identification"
              label="创始人身份证件号码："
              :rules="[{ required: true, message: '请填写创始人身份证件号码', trigger: 'blur' }]"
            >
              <el-input
                class="input-width"
                v-model="params.founder_identification"
                placeholder="请输入创始人身份证件号码"
                maxlength="20"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              prop="founder_birthday"
              label="出生年月："
              :rules="[{ required: true, message: '请选择出生年月', trigger: 'blur' }]"
            >
              <el-date-picker
                v-model="params.founder_birthday"
                value-format="yyyy-MM"
                type="month"
                placeholder="__年__月"
                class="input-width"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item
          label="创始人身份证明材料："
          prop="founder_identification_file"
          :rules="[{ required: true, message: '请上传创始人身份证明材料', trigger: 'blur' }]"
        >
          <div class="myupload">
            <div class="myupload_l">
              <uploadFile :params="params" :apiParams="apiParams2"></uploadFile>
              <input type="hidden" v-model="params.founder_identification_file" />
            </div>
            <div class="myupload_r">
              <p>1.请上传创始人身份证正反面扫描件；如果使用护照或其他证件，请上传相应证件的扫描件；</p>
              <p>2.文件名格式为《创始人姓名-身份证明》，文件格式：PDF、JPG、PNG；文件大小：5M以内。</p>
              <p v-if="params.founder_identification_filePath">
                <a
                  target="_blank"
                  style="color: rgb(50, 130, 255); cursor: pointer; text-decoration: underline;"
                  :href="params.founder_identification_filePath"
                  download="创始人身份证明材料"
                >查看附件</a>
              </p>
              <!-- <div>
                <el-button type="primary" size="mini" @click="viewExamples('id_card')">查看示例</el-button>
              </div>-->
            </div>
          </div>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item
              prop="founder_phone"
              label="手机号码："
              :rules="[{ required: true, message: '请输入手机号码', trigger: 'blur' }]"
            >
              <div>
                <el-input class="input-width" v-model="params.founder_phone" disabled></el-input>
              </div>
              <changeMobile class="input-width" @receiveMobile="receiveMobile"></changeMobile>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              prop="founder_email"
              label="电子邮箱："
              :rules="[
                { required: true, message: '请输入邮箱地址', trigger: 'blur' },
                { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
              ]"
            >
              <el-input class="input-width" v-model="params.founder_email" placeholder="请输入电子邮箱"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="founder_other" label="其他联系方式：">
              <el-input class="input-width" v-model="params.founder_other" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="最高学历："
              prop="founder_education"
              :rules="[{ required: true, message: '请选择最高学历', trigger: 'blur' }]"
            >
              <el-select v-model="params.founder_education" placeholder="请选择" class="input-width">
                <el-option
                  v-for="item in EducationType"
                  :key="item.id"
                  :label="item.name"
                  :value="item.code"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              prop="founder_major"
              label="专业名称："
              :rules="[{ required: true, message: '请输入专业名称', trigger: 'blur' }]"
            >
              <el-input
                class="input-width"
                v-model="params.founder_major"
                placeholder="请输入创业者所学的专业名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              prop="founder_address"
              label="联系地址："
              :rules="[{ required: true, message: '请输入联系地址', trigger: 'blur' }]"
            >
              <el-input
                class="input-width"
                maxlength="100"
                show-word-limit
                v-model="params.founder_address"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="founder_postcode" label="邮政编码：">
              <el-input class="input-width" v-model="params.founder_postcode"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="目前状况："
              prop="founder_status"
              :rules="[{ required: true, message: '请选择目前状况', trigger: 'blur' }]"
            >
              <el-select v-model="params.founder_status" placeholder="请选择" class="input-width">
                <el-option
                  v-for="item in FounderStatus"
                  :key="item.id"
                  :label="item.name"
                  :value="item.code"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item
          label="创业经历:"
          prop="founder_business"
          :rules="[{ required: true, message: '请选择创业经历', trigger: 'blur' }]"
        >
          <el-radio-group v-model="params.founder_business">
            <el-radio label="true">有</el-radio>
            <el-radio label="false">无</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          prop="founder_work"
          label="工作经历："
          :rules="[{ required: true, message: '请输入工作经历', trigger: 'blur' }]"
        >
          <el-input
            maxlength="500"
            type="textarea"
            show-word-limit
            v-model="params.founder_work"
            rows="4"
            placeholder="请输入创始人工作经历"
          ></el-input>
        </el-form-item>
        <h2>项目信息</h2>
        <el-row>
          <el-col :span="12">
            <el-form-item
              prop="incubator"
              label="期望入驻园区："
              :rules="[{ required: true, message: '请选择园区', trigger: 'blur' }]"
            >
              <el-autocomplete
                class="input-width"
                v-model="state2"
                :fetch-suggestions="querySearch"
                placeholder="请输入园区关键词自动匹配"
                :trigger-on-focus="false"
                @select="handleSelect"
              ></el-autocomplete>

              <!-- <el-select
                class="input-width"
                filterable
                v-model="params.incubator"
                placeholder="请输入园区关键词自动匹配"
              >
                <el-option v-for="item in list" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>-->
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              prop="name"
              label="项目/公司名称："
              :rules="[{ required: true, message: '请输入项目/公司名称', trigger: 'blur' }]"
            >
              <el-input class="input-width" maxlength="30" show-word-limit v-model="params.name"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="营业执照扫描件（非必填）：" prop="project_business_file">
          <div class="myupload">
            <div class="myupload_l">
              <uploadFile :params="params" :apiParams="apiParams"></uploadFile>
              <input type="hidden" v-model="params.project_business_file" />
            </div>
            <div class="myupload_r">
              <p>
                1、请上传营业执照或法人证书的原件扫描件，或复印件
                <span
                  style="color: rgb(75, 80, 98); font-weight: 700;"
                >加盖公章</span>扫描件
              </p>
              <p>2、文件名格式为《企业名称-企业营业执照》，格式为PDF，不超过5M</p>
              <p v-if="params.project_business_filePath">
                <a
                  target="_blank"
                  style="color: rgb(50, 130, 255); cursor: pointer; text-decoration: underline;"
                  :href="params.project_business_filePath"
                  download="营业执照"
                >查看附件</a>
              </p>
              <!-- <div>
                <el-button type="primary" size="mini" @click="viewExamples('yingye')">查看示例</el-button>
              </div>-->
            </div>
          </div>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="operation_date" label="营业执照注册时间：">
              <el-date-picker
                class="input-width"
                v-model="params.operation_date"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="如已成立公司，请选择公司成立日期"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="register_money" label="营业执照注册资本（万元）：">
              <el-input
                class="input-width"
                v-model="params.register_money"
                placeholder="如已成立公司，请输入公司注册资本"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="项目现状："
              prop="project_status"
              :rules="[{ required: true, message: '请选择项目现状', trigger: 'blur' }]"
            >
              <el-select v-model="params.project_status" placeholder="请选择" class="input-width">
                <el-option
                  v-for="item in ProjectStatus"
                  :key="item.id"
                  :label="item.name"
                  :value="item.code"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="行业分类："
              prop="fields"
              :rules="[{ required: true, message: '请选择行业分类', trigger: 'blur' }]"
            >
              <el-select v-model="params.fields" placeholder="请选择" class="input-width">
                <el-option v-for="item in Field" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item
          label="项目标签（1~3个）："
          prop="project_lables"
          :rules="[{ required: true, message: '请添加项目标签（1~3个）', trigger: 'blur' }]"
        >
          <tag :dynamicTags="params.project_lables" :size="3" />
        </el-form-item>
        <el-form-item
          label="项目计划书："
          prop="proposal"
          :rules="[{ required: true, message: '请上传项目计划书', trigger: 'blur' }]"
        >
          <div class="myupload">
            <div class="myupload_l">
              <uploadFile :params="params" :apiParams="apiParams3"></uploadFile>
              <input type="hidden" v-model="params.proposal" />
            </div>
            <div class="myupload_r">
              <p v-if="params.incubator && muban.length">
                1.请
                <a
                  class="color_blue"
                  :href="muban"
                  download="项目计划书模板"
                  v-if="params.incubator && muban.length"
                  target="_blank"
                >点击下载项目计划书模板</a>，按照模板提纲提交项目计划书；
              </p>
              <p v-else>1.请上传项目计划书或商业计划书，以便园区对项目进行评估；</p>
              <p>2.文件名格式为《项目/企业名称-项目计划书》，文件格式：PDF、PPT、WORD、RAR、ZIP；文件大小：20MB以内。</p>
              <p v-if="params.proposalPath">
                <a
                  target="_blank"
                  style="color: rgb(50, 130, 255); cursor: pointer; text-decoration: underline;"
                  :href="params.proposalPath"
                  download="项目计划书"
                >查看附件</a>
              </p>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="其他证明（非必填）：">
          <div class="myupload">
            <div class="myupload_l">
              <uploadFile :params="params" :apiParams="apiParams4"></uploadFile>
              <input type="hidden" v-model="params.project_other_file" />
            </div>
            <div class="myupload_r">
              <p>1.可上传其他有助于项目入驻审核的证明材料，如知识产权证明等；</p>
              <p>2.文件名格式为《项目/企业名称-其他证明》，文件格式：PDF、PPT、PPTX、DOC、DOCX；文件大小：10M以内。</p>
              <p v-if="params.project_other_filePath">
                <a
                  target="_blank"
                  style="color: rgb(50, 130, 255); cursor: pointer; text-decoration: underline;"
                  :href="params.project_other_filePath"
                  download="其他证明"
                >查看附件</a>
              </p>
            </div>
          </div>
        </el-form-item>
        <el-form-item prop="synopsis" label="项目简介：">
          <el-input
            maxlength="100"
            type="textarea"
            show-word-limit
            v-model="params.synopsis"
            rows="4"
            placeholder="请用不超过100个字简要介绍本项目的情况"
          ></el-input>
        </el-form-item>
        <h2>
          团队信息
          <span>提示：请点击底部“暂存”按钮后再添加核心人员信息，最多可添加10人信息</span>
        </h2>
        <el-row>
          <!-- <el-col :span="24">
            <el-form-item
              label="团队情况:"
              prop="is_team"
              :rules="[{ required: true, message: '请选择团队情况', trigger: 'blur' }]"
            >
              <el-radio-group v-model="params.is_team">
                <el-radio :label="true">已有团队</el-radio>
                <el-radio :label="false">尚未组队</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>-->
          <el-col :span="24">
            <el-form-item
              prop="personnel"
              label="团队总人数："
              v-if="params.is_team===true"
              :rules="[{ required: true, message: '请填写团队总人数', trigger: 'blur' }]"
            >
              <el-input maxlength="10" class="input-width" v-model="params.personnel"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <team :params="params" v-if="params.code && params.code.length && params.is_team===true" />
        <el-tooltip
          class="item"
          effect="dark"
          content="请点击底部“暂存”按钮后再添加核心人员信息"
          placement="top-start"
          v-else-if="!params.code && params.is_team===true"
        >
          <el-button type="primary" icon="el-icon-plus">添加核心人员信息</el-button>
        </el-tooltip>

        <!-- <el-form-item
          label="团队人员照片:"
          prop="cover"
          :rules="[{ required: true, message: '请上传团队人员照片', trigger: 'blur' }]"
        >
          <div class="myupload">
            <div class="myupload_l">
              <uploadImg :params="params" :apiParams="apiParams7"></uploadImg>
            </div>
            <div class="myupload_r">
              <p>1.请上传团队人员照片；</p>
              <p>2.尺寸200×200像素以上，文件格式：JPG、PNG；文件大小：500KB以内。</p>
            </div>
          </div>
        </el-form-item> -->
        <el-form-item
          label="团队人员照片:"
          prop="image_details"
          :rules="[{ required: true, message: '请上传团队人员照片', trigger: 'blur' }]"
        >
          <div class="myupload">
            <div class="myupload_l">
              <uploadImg :params="params" :apiParams="apiParams8" :isList="true"></uploadImg>
            </div>
            <div class="myupload_r">
              <p>1.请上传团队人员照片；</p>
              <p>2.尺寸200×200像素以上，文件格式：JPG、PNG；文件大小：500KB以内。</p>
            </div>
          </div>
        </el-form-item>
        <!-- <h2>承诺书</h2>
        <el-form-item label="承诺书声明：">
          <div class="myupload">
            <div class="myupload_l">
              <uploadFile :params="params" :apiParams="apiParams6"></uploadFile>
              <input type="hidden" v-model="params.promise" />
            </div>
            <div class="myupload_r">
              <p>
                1.点击
                <a
                  download="承诺书模板"
                  href="https://sctcc-applet.oss-cn-shenzhen.aliyuncs.com/tops/other/%E6%96%B0%E9%A1%B9%E7%9B%AE%E5%85%A5%E9%A9%BB-%E6%89%BF%E8%AF%BA%E4%B9%A6%E5%A3%B0%E6%98%8E.docx"
                  class="color_blue"
                >下载模板</a>，创始人签名或盖公司公章后扫描上传；
              </p>
              <p>2.文件名格式为《项目/企业名称-承诺书声明》，文件格式：PDF/JPG/PNG；文件大小：5M以内。</p>
              <p v-if="params.promisePath">
                <a
                  target="_blank"
                  style="color: rgb(50, 130, 255); cursor: pointer; text-decoration: underline;"
                  :href="params.promisePath"
                  download="承诺书"
                >查看附件</a>
              </p>
            </div>
          </div>
        </el-form-item>-->
        <el-form-item class="form_btm">
          <el-button type="primary" @click="save(false)">暂存</el-button>
          <el-button type="primary" @click="submit(true)">提交审核</el-button>
          <el-button @click="go('admission_to_the_park_table_list');">返回</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 查看示例 -->
    <el-dialog :visible.sync="dialogVisible">
      <div>
        <img :src="viewPhoto" style="width:100%" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import id_card_img from "@/assets/img/ID_Photo/id_card.jpg"; //身份证
import new_yinye from "@/assets/img/ID_Photo/new_yinye.png"; //营业执照
import uploadFile from "@/components/file_upload/uploadFile.vue";
import uploadImg from "@/components/file_upload/uploadImg.vue";
import tag from "@/components/tag/tag.vue";
import changeMobile from "@/components/changeMobile/change_mobile";
import team from "../components/add_team.vue";
import AppCropper from "@/components/crop_picture/Cropper.vue"; //裁剪图片(单图)
export default {
  components: {
    uploadFile,
    uploadImg,
    changeMobile,
    tag,
    team,
    AppCropper
  },
  data() {
    return {
      id_card_img: id_card_img,
      new_yinye: new_yinye,
      viewPhoto: "", //预览图片
      params: {
        is_team: true,
        project_lables: [] //标签
      },
      dialogVisible: false,
      state2: "", //输入搜索框的搜索的值
      restaurants: [], //园区列表
      uploadParams: {
        //封面
        fixedNumber: [1, 1],
        shape: "rectangle",
        size: 0.5,
        ziduan: "founder_cover",
        filePathfield: "founder_coverPath"
      },
      /** 文件上传参数*/
      apiParams: {
        params: {
          catalog: "CatalogActivityCover"
        },
        size: 5, //文件大小
        type: "pdf", //类型
        imgPath: "project_business_filePath", //文件路径字段
        fileId: "project_business_file" //文件id字段
      },
      apiParams2: {
        params: {
          catalog: "CatalogActivityCover"
        },
        size: 5, //文件大小
        type: "tupian|pdf", //类型
        imgPath: "founder_identification_filePath", //文件路径字段
        fileId: "founder_identification_file" //文件id字段
      },
      apiParams3: {
        params: {
          catalog: "CatalogActivityCover"
        },
        size: 20, //文件大小
        type: "wendang|ysb", //类型
        imgPath: "proposalPath", //文件路径字段
        fileId: "proposal" //文件id字段
      },
      apiParams4: {
        params: {
          catalog: "CatalogActivityCover"
        },
        size: 10, //文件大小
        type: "wendang",
        imgPath: "project_other_filePath", //文件路径字段
        fileId: "project_other_file" //文件id字段
      },
      apiParams5: {
        params: {
          catalog: "CatalogUserHead",
          is_public_read: true
        },
        imgPath: "founder_coverPath", //图片展示字段
        fileId: "founder_cover" //文件id字段
      },
      // apiParams6: {
      //   params: {
      //     catalog: "CatalogActivityCover"
      //   },
      //   size: 5, //文件大小
      //   type: "tupian|pdf", //类型 pdf ysb(压缩包包含rar和zip) zip rar
      //   imgPath: "promisePath", //文件路径字段
      //   fileId: "promise" //文件id字段
      // },
      // apiParams7: {
      //   params: {
      //     catalog: "CatalogUserHead",
      //     is_public_read: true
      //   },
      //   imgPath: "coverPath", //图片展示字段
      //   fileId: "cover" //文件id字段
      // },
      apiParams8: {
        params: {
          catalog: "CatalogUserHead",
          is_public_read: true
        },
        imgPath: "image_detailsPath",
        fileId: "image_details",
        limit:8
      },
      EducationType: [], //学历
      FounderStatus: [], // 创始人现状
      ProjectStatus: [], //项目现状
      Field: [], //领域
      muban: "" //中台-园区信息-模板文件管理-新项目计划书模板文件的链接
    };
  },
  computed: {
    info() {
      return this.$store.state.info;
    }
  },
  created() {
   
    if (this.info) {
      this.initPage(); /** 查询认证 用于二次编辑*/
    } else {
      this.needInfo("initPage");
    }
    this.getDict("EducationType", "EducationType"); //学历
    this.getDict("FounderStatus", "FounderStatus"); //创始人现状
    this.getDict("ProjectStatus", "ProjectStatus"); //项目现状
    this.getDict("Field", "Field"); //领域

    // let _html = `<div>
    // <p style="text-indent:28px;">上述项目入驻申请信息由申请人同意无偿提供，由主办单位管理使用。</p>
    // <p style="text-indent:28px;">申请人承诺提供的信息、文件和资料真实、可靠、完整，作品的知识产权权利归属明确无争议；未剽窃他人成果；未侵犯他人的知识产权。</p>
    // <p style="text-indent:28px;">若发生与上述承诺相违背的情形，由申报人自行承担全部法律责任。</p>
    // </div>`;
    // this.$confirm(_html, "声明", {
    //   dangerouslyUseHTMLString: true,
    //   confirmButtonText: "同意声明并确定提交审核",
    //   cancelButtonText: "取消"
    // })
    //   .then(() => {
    //     this.save(type);
    //   })
    //   .catch(() => {});
    // this.$msgbox({
    //   title: '声明',
    //   message:_html,
    //     dangerouslyUseHTMLString: true,
    //   confirmButtonText: "同意声明并确定提交审核",
    //   cancelButtonText: "取消",
    //   beforeClose:(action, instance, done) => {

    //   }
    // })
  },
  mounted() {
    
  },
  methods: {
    async initPage(){
       await this.getList(); // 获取所有园区列表
       await this.getEnterprises(); /** 查询认证 用于二次编辑*/
    },
    // 单图截图后返回的路径和id
    uploadObj(params) {
      let obj = new Object();
      obj[params.ziduan] = params.fileId;
      obj[params.filePathfield] = params.filePath;
      this.params = Object.assign({}, this.params, obj);
    },
    /** 提交表单验证*/
    submit(type) {
      this.$refs["from"].validate(valid => {
        if (valid) {
          // let _html = `上述项目入驻申请信息由申请人同意无偿提供，由主办单位管理使用。</br>申请人承诺提供的信息、文件和资料真实、可靠、完整，作品的知识产权权利归属明确无争议；未剽窃他人成果；未侵犯他人的知识产权。</br>若发生与上述承诺相违背的情形，由申报人自行承担全部法律责任。`;
          // this.$confirm(_html, "提示", {
          //   dangerouslyUseHTMLString: true,
          //   confirmButtonText: "确定",
          //   cancelButtonText: "取消",
          //   center: true
          // })
          //   .then(() => {
          //     this.save(type);
          //   })
          //   .catch(() => {});
          let _html = `<div>
          <p style="text-indent:28px;">上述项目入驻申请信息由申请人同意无偿提供，由主办单位管理使用。</p>
          <p style="text-indent:28px;">申请人承诺提供的信息、文件和资料真实、可靠、完整，作品的知识产权权利归属明确无争议；未剽窃他人成果；未侵犯他人的知识产权。</p>
          <p style="text-indent:28px;">若发生与上述承诺相违背的情形，由申报人自行承担全部法律责任。</p>
          </div>`;
          this.$confirm(_html, "声明", {
            dangerouslyUseHTMLString: true,
            confirmButtonText: "同意声明并确定提交审核",
            cancelButtonText: "取消"
          })
            .then(() => {
              this.save(type);
            })
            .catch(() => {});
        } else {
          this.$message.info("请检测必填项!");
          return false;
        }
      });
    },
    /* 监测Props */
    needInfo(name) {
      let watchAch = this.$watch("info", (val, oldVal) => {
        if (val) {
          this[name]();
          watchAch(); //取消监听
        }
      });
    },
    // 获取所有园区列表
    getList() {
      return this.api.getList().then(res => {
        if (res.error["err_code"] !== 0) return;
        let list = res.obj.list || [];
        list.forEach(item => {
          item.value = item.name;
        });
        this.restaurants = list;
      });
    },
    /** 查询认证*/
    getEnterprises() {
      let id =
        this.$route.query.id ||
        sessionStorage.getItem("adminToParkCertificationTmpId");
      if (!id) {
        this.params = Object.assign({}, this.params, {
          founder_phone: this.info.mobile
        });
        return;
      }
      let params = {
        id: id,
        entity_type: "EnterpriseEntityTypeSettled",
        user_id: this.info.id
      };
      this.api.getEnterprises(params).then(res => {
        if (res.error["err_code"] !== 0) return;
        let list = res.obj.list || [];
        let obj = list.length ? res.obj.list[0] : {};
        if (!obj || !obj.founder_phone) {
          obj.founder_phone = this.info.mobile;
        }
        obj.fields = obj.field_id;
        obj.project_lables =
          obj.project_lables && obj.project_lables.length
            ? obj.project_lables.split(",")
            : [];
        obj.is_team = true;
        this.state2 = obj.incubator_name || "";
        this.params = Object.assign({}, this.params, obj);
        let restaurants = this.restaurants;//园区列表
        restaurants.map(item=>{
          if(item.id === obj.incubator){
            this.getExtends(item.code);//模板文件
          }
          
        })
      });
    },

    /** 保存表单内容*/
    save(type) {
      let operation = !type
        ? "IdentityCertifieStatusNotSubmitted"
        : "IdentityCertifieStatusSubmitted"; //保存或提交
      let project_lables =
        this.params.project_lables && this.params.project_lables.length
          ? this.params.project_lables.join(",")
          : "";
      let params = Object.assign({}, this.params, {
        operation,
        project_lables
      });
      this.api.saveOrSubmitEnterprise(params).then(res => {
        if (res.error["err_code"] !== 0) return;
        this.$message.success("操作成功");
        //暂存
        if (!type) {
          let tmpId = res.obj.id;
          sessionStorage.setItem("adminToParkCertificationTmpId", tmpId);
          this.getEnterprises();
        } else {
          //提交
          this.go("admission_to_the_park_table_list");
        }
      });
    },
    go(name) {
      this.$router.push({
        name: name
      });
    },
    //更换手机号（子组件传值）
    receiveMobile(obj) {
      this.params = Object.assign({}, this.params, {
        founder_phone: obj.mobile
      });
    },
    viewExamples(tmp) {
      this.viewPhoto = "";
      if (tmp === "yingye") {
        this.viewPhoto = this.new_yinye;
      } else if (tmp === "shui") {
        this.viewPhoto = this.shui;
      } else if (tmp === "id_card") {
        this.viewPhoto = this.id_card_img;
      } else if (tmp === "chengluo") {
        this.viewPhoto = this.chengluo;
      }
      this.dialogVisible = true;
    },
    //获取字典
    getDict(typeCode, key) {
      this.api
        .getDictionaries({
          pageSize: 999,
          typeCode: typeCode
        })
        .then(res => {
          if (res.error["err_code"] !== 0) return;
          this[key] = res.obj.list;
        });
    },
    // 输入搜索
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      console.log(results);
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    // 搜索筛选条件
    createFilter(queryString) {
      return restaurant => {
        return (
          restaurant.name.toLowerCase().indexOf(queryString.toLowerCase()) > -1
        );
      };
    },
    // 选中筛选结果
    handleSelect(item) {
      console.log(item)
      this.$set(this.params, "incubator", item.id);
      this.getExtends(item.code);
    },
    // 模板文件
    getExtends(code) {
      let params = {
        type: "StarryExtendTypeFileTemplate",
        code: code
      };
      this.api.getExtends(params, true).then(res => {
        if (res.error["err_code"] !== 0) return;
        let obj = res.obj.list[0];
        if (res.obj.list) {
          this.muban = res.obj.list.length ? obj.project_templatePath : "";
        }
      });
    }
  }
};
</script>

<style lang="scss">
.el-message-box__title{
  text-align: center
}
.enterprise_form {
  h2 {
    font-size: 20px;
    font-weight: 700;
    line-height: 40px;
    span {
      font-size: 14px;
      font-weight: 500;
      margin-left: 10px;
    }
  }
  .my_cropper .rectangle .el-upload-dragger {
    width: 80px;
    height: 80px;
  }
  .form_btm {
    z-index: 999;
    text-align: center;
    position: fixed;
    bottom: 0;
    width: 100%;
    text-align: center;
    left: 0;
    right: 0;
    margin: 0 auto;
    padding: 20px 0;
    background: #fff;
    box-shadow: 0 2px 10px #999;
  }
  .color_blue {
    color: #4c84ff;
  }
}
</style>
